import { CommonModule, DatePipe } from '@angular/common'
import { Component, Input, OnChanges } from '@angular/core'
import { FormsModule, ReactiveFormsModule, UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms'
import { ButtonComponent } from '@progress/kendo-angular-buttons'
import { DateInputCustomFormatPlaceholder, DatePickerComponent } from '@progress/kendo-angular-dateinputs'
import { DropDownListComponent } from '@progress/kendo-angular-dropdowns'
import { AddCommandDirective, CancelCommandDirective, CellTemplateDirective, ColumnComponent, CommandColumnComponent, DataBindingDirective, EditCommandDirective, EditTemplateDirective, FocusableDirective, GridComponent, GridToolbarFocusableDirective, SaveCommandDirective, ToolbarTemplateDirective } from '@progress/kendo-angular-grid'
import { TextBoxDirective } from '@progress/kendo-angular-inputs'
import { ClientServices } from '../../../../@theme/services/clients.service'
import { TypesServices } from '../../../../@theme/services/typeslist.service'
import { RepSocialMedia } from '../../../../models/repEditorModels'
import { Utilities } from '../../../../utilities/utilities'
import { GridEditorBaseComponent } from '../../shared/rep-editor-base/grid-editor-base-component'
import { RepEditorStateService } from '../../shared/rep-editor-state.service'
import { AdminOnlyDirective } from '../shared/admin-only.directive'

@Component({
    selector: 'gd-rep-editor-social-media',
    templateUrl: './rep-editor-social-media.component.html',
    styleUrls: ['./rep-editor-social-media.component.scss'],
    imports: [
        CommonModule,
        GridComponent,
        DataBindingDirective,
        ToolbarTemplateDirective,
        GridToolbarFocusableDirective,
        AddCommandDirective,
        ButtonComponent,
        ColumnComponent,
        EditTemplateDirective,
        DropDownListComponent,
        FormsModule,
        ReactiveFormsModule,
        TextBoxDirective,
        CellTemplateDirective,
        DatePickerComponent,
        CommandColumnComponent,
        FocusableDirective,
        EditCommandDirective,
        SaveCommandDirective,
        CancelCommandDirective,
        DatePipe,
        AdminOnlyDirective
    ]
})
export class RepEditorSocialMediaComponent
  extends GridEditorBaseComponent
  implements OnChanges
{
  @Input() override repId: number = 0
  repSocialMedia: RepSocialMedia[]
  approvedSocialMedia: any[]
  activeApprovedSocialMedia = this.repState.getActiveApprovedSocialMedia()
  public asDateInput = (value) =>
    Utilities.asType<DateInputCustomFormatPlaceholder>(value)

  constructor(
    typesService: TypesServices,
    clientService: ClientServices,
    formBuilder: UntypedFormBuilder,
    repEditorStateService: RepEditorStateService,
  ) {
    super(typesService, clientService, formBuilder, repEditorStateService)
  }

  ngOnChanges() {
    this.checkGridState()

    if (!this.repState.repSocialMedia) {
      this.initGrid()
    }

    if (!this.repState.approvedSocialMedia) {
      this.typesService.getApprovedSocialMedia().subscribe((response) => {
        this.repState.approvedSocialMedia = response
      })
    }
  }

  initGrid() {
    this.clientService
      .getRepSocialMediaForRep({ repId: this.repId })
      .subscribe((response) => {
        this.repState.repSocialMedia = response.map(
          (rsm) => new RepSocialMedia(rsm),
        )
      })
  }

  public addHandler({ sender }) {
    const newRepSocialMedia = new RepSocialMedia(null)
    newRepSocialMedia.repID = this.repId
    this.addHandlerShared({ sender }, newRepSocialMedia)
  }

  public saveHandler({ sender, rowIndex, formGroup, isNew }): void {
    const repSocialMedia = new RepSocialMedia(formGroup.value)
    this.clientService
      .submitRepSocialMediaUpdate(repSocialMedia)
      .subscribe(() => {
        sender.closeRow(rowIndex)
        this.initGrid()
      })
  }

  public removeHandler({ dataItem }) {
    throw new Error('Method not implemented.')
  }

  public createFormGroup(repSocialMedia: RepSocialMedia): UntypedFormGroup {
    return this.formBuilder.group({
      repSocialMediaID: repSocialMedia.repSocialMediaID,
      repID: repSocialMedia.repID,
      approvedSocialMediaID: [
        repSocialMedia.approvedSocialMediaID,
        Validators.required,
      ],
      socialMedia: repSocialMedia.socialMedia,
      accountName: repSocialMedia.accountName,
      startDate: repSocialMedia.startDate,
      endDate: repSocialMedia.endDate,
    })
  }
}
